/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAuthSimpleClientFromJSON, ApiAuthSimpleClientToJSON, } from './ApiAuthSimpleClient';
export function ApiListUserClientsResponseFromJSON(json) {
    return ApiListUserClientsResponseFromJSONTyped(json, false);
}
export function ApiListUserClientsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clients': !exists(json, 'clients') ? undefined : (json['clients'].map(ApiAuthSimpleClientFromJSON)),
    };
}
export function ApiListUserClientsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clients': value.clients === undefined ? undefined : (value.clients.map(ApiAuthSimpleClientToJSON)),
    };
}
